export const PANEL_WIDTH = 285;
export const PAINS_WIDTH = PANEL_WIDTH - 32 - 2; // PANEL_WIDTH - 2 * padding - 2 * border
export const PAINS_GAP = 10;
export const PAINS_ROWS_MAX = 2;
export const PAIN_HEIGHT = 24;
export const MORE_LABEL_MAX_WIDTH = 40;
